<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Certificados</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Certificados</div>
        </div>
        <button class="appui-btn appui-btn--ghost" @click="preview()"><i class="mdi mdi-file-eye-outline mr-1"></i> Ver certificado</button>
      </div>

      <div class="appui-cert-grid">
        <div>
          <!-- Liberação -->
          <section class="appui-card" style="padding:22px 24px">
            <h2 class="appui-sec-title">Liberação</h2>
            <p class="appui-sec-sub">Como o participante acessa o certificado no app.</p>
            <div class="appui-grid-2">
              <div>
                <label class="appui-label">Certificado</label>
                <select class="appui-input" v-model.number="interactions.certificate" @change="saveInteractions()">
                  <option :value="1">Autorizado</option>
                  <option :value="0">Suspenso</option>
                </select>
              </div>
              <div>
                <label class="appui-label">Condição para liberar</label>
                <select class="appui-input" v-model.number="interactions.certificate_type" @change="saveInteractions()">
                  <option :value="0">Livre</option>
                  <option :value="1">Exige responder a pesquisa</option>
                </select>
              </div>
            </div>
          </section>

          <!-- Modelo (páginas) -->
          <section class="appui-card appui-card--flush">
            <div class="appui-card-toolbar">
              <div class="appui-card-toolbar-left">
                <span class="appui-sec-title">Modelo <small style="font-weight:400;color:#74788d">— a 1ª página recebe o nome do participante</small></span>
              </div>
              <div class="appui-card-toolbar-right">
                <button class="appui-btn appui-btn--primary" @click="openPage()">+ Adicionar página</button>
              </div>
            </div>
            <div v-if="!pages.length" class="appui-inline-empty">Nenhuma página configurada — adicione o fundo do certificado.</div>
            <table v-else class="appui-table">
              <thead><tr><th style="width:70px">Página</th><th>Fundo</th><th style="width:130px">Posição do nome</th><th style="width:110px">Fonte</th><th style="width:150px;text-align:right">Ações</th></tr></thead>
              <tbody>
                <tr v-for="(p, i) in pages" :key="p.id">
                  <td><span class="appui-badge appui-badge--blue">{{ p.page }}</span></td>
                  <td>
                    <img v-if="p.image" :src="p.image" style="width:96px;height:58px;object-fit:cover;border-radius:6px;border:1px solid #eff2f7">
                    <span v-else style="color:#adb5bd">sem imagem</span>
                  </td>
                  <td style="color:#74788d">{{ i === 0 ? (p.position_x + ', ' + p.position_y) : '—' }}</td>
                  <td>
                    <span v-if="i === 0" :style="{ color: 'rgb(' + (p.font_color || '0,0,0') + ')', fontWeight: 700 }">{{ p.font_size || 30 }}px</span>
                    <span v-else style="color:#adb5bd">—</span>
                  </td>
                  <td style="text-align:right;white-space:nowrap">
                    <button class="appui-tbtn" style="margin-right:6px" @click="openPage(p)">Editar</button>
                    <button class="appui-tbtn appui-tbtn--danger" @click="removePage(p)">Excluir</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </div>

        <!-- Emitidos -->
        <section class="appui-card appui-card--flush" style="align-self:start">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left"><span class="appui-sec-title">Emitidos</span></div>
            <div class="appui-card-toolbar-right">
              <button class="appui-btn appui-btn--ghost appui-btn--sm" @click="loadIssued()"><i class="mdi mdi-refresh"></i></button>
            </div>
          </div>
          <div style="text-align:center;padding:18px 16px 6px">
            <div style="font-size:34px;font-weight:800;color:#556ee6;line-height:1">{{ issuedTotal }}</div>
            <div style="font-size:11.5px;color:#adb5bd;margin-top:4px">certificados gerados</div>
          </div>
          <div v-if="issued.length" style="padding:8px 0 4px">
            <div v-for="c in issued" :key="c.id" style="display:flex;justify-content:space-between;gap:10px;padding:8px 16px;border-top:1px solid #f4f5f8;font-size:12.5px">
              <span style="color:#495057;font-weight:500;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ c.participant ? c.participant.name : '#' + c.participant_id }}</span>
              <span style="color:#adb5bd;flex:none">{{ fmtDate(c.created_at) }}</span>
            </div>
          </div>
        </section>
      </div>
    </div>

    <b-modal v-model="showModal" :title="form.id ? 'Editar página' : 'Nova página'" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group">
          <label>Fundo (PNG/JPG paisagem)</label>
          <input type="file" accept="image/*" ref="image" style="display:none" @change="onImage">
          <div class="appui-drop" :class="{ 'has-img': imagePreview }" style="min-height:130px" @click="$refs.image.click()">
            <template v-if="imagePreview">
              <img :src="imagePreview" class="appui-drop-img">
              <div class="appui-drop-overlay"><span class="appui-drop-btn"><i class="mdi mdi-swap-horizontal"></i> Trocar</span></div>
            </template>
            <template v-else>
              <i class="mdi mdi-cloud-upload-outline appui-drop-icon"></i>
              <span class="appui-drop-title">Clique para enviar</span>
              <span class="appui-drop-hint">Paisagem · até 8 MB</span>
            </template>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Posição X do nome</label><input type="number" class="form-control" v-model.number="form.position_x"></div>
          <div class="form-group col-sm-6"><label>Posição Y do nome</label><input type="number" class="form-control" v-model.number="form.position_y"></div>
        </div>
        <div class="row">
          <div class="form-group col-sm-6"><label>Cor do texto (R,G,B)</label><input type="text" class="form-control" v-model="form.font_color" placeholder="255,255,255"></div>
          <div class="form-group col-sm-6"><label>Tamanho da fonte</label><input type="text" class="form-control" v-model="form.font_size" placeholder="30"></div>
        </div>
        <small class="text-muted d-block mb-3">A posição/cor/tamanho valem para a 1ª página (onde o nome é aplicado).</small>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button><button type="submit" class="btn btn-primary" :disabled="saving">Salvar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import http from '@/http'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-certificates',
  data () {
    return {
      pages: [],
      issued: [],
      issuedTotal: 0,
      interactions: { certificate: 0, certificate_type: 0 },
      showModal: false,
      saving: false,
      form: {},
      imageFile: null,
      imagePreview: null
    }
  },
  mounted () {
    this.load()
    this.loadIssued()
    services.getAppSettings().then(r => {
      const it = r.data.data.interactions || {}
      this.interactions = { certificate: it.certificate ? 1 : 0, certificate_type: it.certificate_type ? 1 : 0 }
    }).catch(() => {})
  },
  methods: {
    load () { services.listCertificatePages().then(r => { this.pages = r.data.data }).catch(() => errorMessage('Falha ao carregar.', 3000)) },
    loadIssued () {
      services.listCertificatesIssued().then(r => {
        this.issued = r.data.data || []
        this.issuedTotal = r.data.total != null ? r.data.total : this.issued.length
      }).catch(() => {})
    },
    fmtDate (d) {
      if (!d) return ''
      const dt = new Date(String(d).replace(' ', 'T'))
      if (isNaN(dt)) return d
      return dt.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })
    },
    async saveInteractions () {
      try {
        await services.updateInteractions({ certificate: this.interactions.certificate, certificate_type: this.interactions.certificate_type })
        successMessage('Liberação atualizada.', 1500)
      } catch (e) { errorMessage('Falha ao salvar liberação.', 3000) }
    },
    openPage (p) {
      this.form = p ? { ...p } : { position_x: 88, position_y: 26, font_color: '255,255,255', font_size: '16' }
      this.imageFile = null
      this.imagePreview = p ? p.image : null
      this.showModal = true
    },
    onImage (e) {
      const f = e.target.files[0]
      e.target.value = ''
      if (!f) return
      if (!f.type.startsWith('image/')) { errorMessage('Envie um arquivo de imagem.', 2500); return }
      if (f.size > 8 * 1024 * 1024) { errorMessage('A imagem deve ter no máximo 8 MB.', 2500); return }
      this.imageFile = f
      this.imagePreview = URL.createObjectURL(f)
    },
    async save () {
      this.saving = true
      try {
        const fd = new FormData()
        ;['id', 'page', 'position_x', 'position_y', 'font_color', 'font_size'].forEach(k => { if (this.form[k] != null) fd.append(k, this.form[k]) })
        if (this.imageFile) fd.append('image', this.imageFile)
        await services.saveCertificatePage(fd)
        this.showModal = false
        successMessage('Página salva.', 2000)
        this.load()
      } catch (e) { errorMessage('Falha ao salvar.', 3000) } finally { this.saving = false }
    },
    async removePage (p) {
      const ok = await this.$bvModal.msgBoxConfirm('Remover esta página?', { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteCertificatePage(p.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async preview () {
      try {
        const res = await http.get('/admin/app/certificate/example', { responseType: 'blob' })
        window.open(URL.createObjectURL(res.data), '_blank')
      } catch (e) { errorMessage('Configure ao menos uma página primeiro.', 3000) }
    }
  }
}
</script>
